import { Check, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY } from "@/data/site";
import { Overline, Reveal } from "@/components/Reveal";

const PROMISES = [
  "You deal directly with the owner — never a salesperson",
  "On every job site, from demo to final walkthrough",
  "Answers his own phone, seven days a week",
];

const OwnerSection = () => (
  <section className="bg-cream py-16 md:py-24" data-testid="owner-section">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 lg:grid-cols-[1fr_1.2fr] lg:px-10">
      <Reveal>
        <div className="relative mx-auto max-w-md">
          <div className="absolute -inset-3 rounded-[2rem] border-2 border-salmon/40" aria-hidden="true" />
          <img
            src="/assets/owner.webp"
            alt="Diego, owner of Gregory Tile, beside his work truck in Huntsville, Alabama"
            data-testid="owner-photo"
            loading="lazy"
            className="relative aspect-[4/5] w-full rounded-[1.75rem] object-cover shadow-2xl"
          />
          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-navy px-6 py-3 shadow-xl">
            <p className="font-serif text-lg font-bold text-white">Diego</p>
            <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-salmon-vibrant">
              Owner
            </p>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <Overline>Meet the Owner</Overline>
        <h2 className="mt-3 font-serif text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
          Meet Diego
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-600">
          I work directly with every client from the first estimate through the finished project. My crew and I focus on quality work and attention to detail.
        </p>
        <p className="mt-4 text-base leading-relaxed text-slate-600">
          Born and raised in North Alabama, Diego built this company the slow way: one shower, one kitchen, one floor at a time — earning referrals across Huntsville, Madison and Athens by doing exactly what the estimate says, for exactly what it says.
        </p>
        <ul className="mt-6 space-y-2.5">
          {PROMISES.map((p) => (
            <li key={p} className="flex items-center gap-2.5 text-sm font-medium text-navy">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-salmon">
                <Check className="h-3 w-3 text-white" strokeWidth={3.5} />
              </span>
              {p}
            </li>
          ))}
        </ul>
        <div className="mt-8 flex flex-wrap gap-3">
          <a
            href={COMPANY.phoneHref}
            data-testid="owner-call-button"
            className="flex items-center gap-2 rounded-full bg-navy px-6 py-3 text-sm font-bold text-white shadow-md transition-all hover:bg-navy-light hover:shadow-lg"
          >
            <Phone className="h-4 w-4" /> Call Diego Directly
          </a>
          <Link
            to="/contact"
            data-testid="owner-estimate-button"
            className="rounded-full border-2 border-navy px-6 py-3 text-sm font-bold text-navy transition-colors hover:bg-navy hover:text-white"
          >
            Get Free Estimate
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default OwnerSection;
